import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DjPsycho} from "../DjPsycho";
import {DjPsychoSymbol, DjPsychoSymbolStates} from "../reels/DjPsychoSymbol";
import {TimelineLite} from "gsap";
import {IStateMatrixCoordinate} from "../utils/StateMatrix";
import {IWinClusterData} from "../server/IDjPsychoData";
import {DjPsychoSound} from "../sound/DjPsychoSound";

export class DjPsychoWinRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return (DjPsycho.model.gameData.betClusterWins.length > 0);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: TimelineLite = new TimelineLite({
                delay: 0.2,
                onComplete: () => {
                    controller.finish();
                }
            }),
            labels: string[] = ["", "", "", "", ""],
            offsets: number[] = [0, 0, 0, 0, 0],
            canPlayFrame: boolean = ((DjPsycho.model.gameData.totalSpinWinnings / DjPsycho.model.gameData.playedBetValue) > 5),
            betClusterWins: IWinClusterData[] = DjPsycho.model.gameData.betClusterWins,
            brokeBank: boolean = DjPsycho.model.gameData.brokeBank,
            winCoords: IStateMatrixCoordinate[] = DjPsycho.model.winMatrix.getAllCoordinateForValue(DjPsychoSymbolStates.WIN),
            noWinCoords: IStateMatrixCoordinate[] = DjPsycho.model.winMatrix.getAllCoordinateForValue(DjPsychoSymbolStates.NO_WIN);

        tl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });
        }, 0);

        for (let cord of noWinCoords) {
            tl.add(DjPsycho.reelView.getVisibleSymbolAt(cord.column, cord.row).setState(DjPsychoSymbolStates.NO_WIN), 0);
        }

        betClusterWins.forEach((cluster: IWinClusterData) => {
            const label: string = cluster.symbol[1],
                idx: number = ((+label) - 1),
                symbolAnim: TimelineLite = new TimelineLite();

            if (labels[idx] === "") {
                labels[idx] = label;
                tl.addLabel(label);
                tl.add(() => {
                    DjPsycho.soundPlayer.playSound(DjPsychoSound.BET_LINE_HIGHLIGHT);
                }, label);
            }

            symbolAnim.add(DjPsycho.winView.groupWinAnim(cluster.reelWinPositions, cluster.multipliedAmount, cluster.multiplier), offsets[idx]);
            symbolAnim.add(DjPsycho.miniCollectors.activateColorIndicators(parseInt(cluster.symbol[1]) - 1, true));

            cluster.reelWinPositions.forEach((values: boolean[], reelId: number) => {
                values.forEach((value: boolean, symId: number) => {
                    if (value) {
                        const sym: DjPsychoSymbol = DjPsycho.reelView.getVisibleSymbolAt(reelId, symId);

                        symbolAnim.add(sym.setState(DjPsychoSymbolStates.WIN), 0);
                    }
                });
            });

            tl.add(symbolAnim, label);

            offsets[idx] += 0.2;
        });

        tl.add(() => {
            DjPsycho.keypadPlugin.setWin(DjPsycho.model.gameData.accumulatedRoundWin, true, DjPsycho.isWinBelowStake());
        });
        tl.addLabel("allHighlighted");
        for (let cord of winCoords) {
            const sym: DjPsychoSymbol = DjPsycho.reelView.getVisibleSymbolAt(cord.column, cord.row),
                allSymbolsAnim: TimelineLite = new TimelineLite();

            allSymbolsAnim.add(() => {
                sym.setState(DjPsychoSymbolStates.NORMAL);
            }, 0);
            allSymbolsAnim.add(DjPsycho.winView.playWinAnimation(cord.column, cord.row, canPlayFrame), 0);
            if (!brokeBank) {
                allSymbolsAnim.add(sym.disappear(), (10 / 30));
            }
            tl.add(allSymbolsAnim, "allHighlighted");
        }
        if (!brokeBank) {
            tl.add(() => {
                DjPsycho.soundPlayer.playSound(DjPsychoSound.BET_LINES_REMOVE);

                DjPsycho.miniCollectors.burnCollectorsInSFS();
            }, "allHighlighted");
        }

        tl.to(this, {duration: 0.1});
    }

    private onSkip(tl: TimelineLite): void {
        let numOfCluster: number = DjPsycho.model.gameData.betClusterWins.length;
        if (numOfCluster <= 2) {
            tl.timeScale(3);
        } else if (numOfCluster >= 3 && numOfCluster <= 5) {
            tl.timeScale(5);
        } else {
            tl.totalProgress(1);
        }
    }
}